import { render } from "./nft-collection.vue?vue&type=template&id=5a4f6c3a"
import script from "./nft-collection.vue?vue&type=script&lang=js"
export * from "./nft-collection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__